import { useEffect } from "react";

/**
 * Toggled on `<html>` while any Care route is mounted. Matching CSS is injected
 * by this hook because `::-webkit-scrollbar` cannot be set as an inline style.
 */
export const HIDE_SCROLLBAR_CLASS = "care-hide-scrollbar";

const STYLE_ATTR = "data-care-hide-scrollbar";

const HIDE_SCROLLBAR_CSS = `
html.${HIDE_SCROLLBAR_CLASS},
html.${HIDE_SCROLLBAR_CLASS} body {
  scrollbar-width: none;
}
html.${HIDE_SCROLLBAR_CLASS}::-webkit-scrollbar,
html.${HIDE_SCROLLBAR_CLASS} body::-webkit-scrollbar {
  display: none;
}
`;

const ensureStyleElement = () => {
  if (document.head.querySelector(`style[${STYLE_ATTR}]`)) {
    return;
  }

  const style = document.createElement("style");
  style.setAttribute(STYLE_ATTR, "");
  style.textContent = HIDE_SCROLLBAR_CSS;
  document.head.appendChild(style);
};

const removeStyleElement = () => {
  document.head.querySelector(`style[${STYLE_ATTR}]`)?.remove();
};

/**
 * Hides the document scrollbar chrome while the calling component is mounted.
 *
 * Only the visual bar is removed — the page still scrolls via touch, wheel,
 * trackpad, and keyboard.
 */
export const useHideDocumentScrollbar = (): void => {
  useEffect(() => {
    document.documentElement.classList.add(HIDE_SCROLLBAR_CLASS);
    ensureStyleElement();

    return () => {
      document.documentElement.classList.remove(HIDE_SCROLLBAR_CLASS);
      removeStyleElement();
    };
  }, []);
};
